import { institutionTypeDomaine, roles } from "../../../utils/constants";
import { useParams } from "react-router-dom";
import routes from "../../../engine/routes";
import { onlyRoleMapping, userHasLevel } from "../../../engine/AuthRoute";
import {
  mainTypesPrestation,
  typesPrestation,
} from "../../../utils/typesPrestation";
import { Button, notification } from "antd";
import { http } from "../../../engine/api/http";
import React, { useContext } from "react";
import BillingsType from "./index";
import { useTranslation } from "react-i18next";
import { customers, onlyCustomers } from "../../../engine/customerConfig";
import { UserContext } from "../../../engine/context/User.context";

export const institutionsDetailinputs = ({ institution, formRef, user }) => {
  const { t } = useTranslation();
  const {
    name,
    secondName,
    type,
    archived,
    principal,
    mainType,
    category = undefined,
    groupedBilling,
    minimumMinutesTranches,
    tags,
    restrictionPerApplicant,
    interventionLocation,
    includeSignInBill,
    billings,
  } = institution;
  const { id } = useParams();

  const { configuration } = useContext(UserContext);

  return [
    {
      parentLabel: "",
      children: [
        {
          label: t("institutionsDetailInputs.nameLabel1"),
          name: "name",
          value: name,
          required: true,
          type: "input",
          capitalize: false,
          col: 24,
        },
        {
          label: t("institutionsDetailInputs.nameLabel2"),
          name: "secondName",
          value: secondName,
          type: "input",
          col: 24,
        },
        {
          value: mainType,
          label: t("institutionsDetailInputs.mainType"),
          name: "mainType",
          showSearch: true,
          type: "select",
          selectContent: typesPrestation(),
          // selectType: "select",
          onChange: e => {
            // On change reset category
            formRef.current.setFieldsValue({ category: undefined });
          },
          col: 24,
        },
        {
          value: category,
          defaultValue: category,
          label: t("institutionsDetailInputs.category"),
          placeholder: t("institutionsDetailInputs.category"),
          name: "category",
          showSearch: true,
          type: "select",
          selectContent: form => {
            let mainTypeForm = form.getFieldValue("mainType");
            return typesPrestation(mainTypeForm);
          },
          watch: "mainType",
          // selectType: "select",
          col: 24,
        },
        // {
        //   value: interventionLocation,
        //   label: t("institutionsDetailInputs.interventionLocation"),
        //   name: "interventionLocation",
        //   type: "google-adress",
        //   col: 24,
        // },
      ],
    },
    {
      parentLabel: t("institutionsDetailInputs.settings"),
      children: [
        {
          value: tags,
          label: t("institutionsDetailInputs.tags"),
          name: "tags",
          multiple: "true",
          disabled: true,
          showSearch: true,
          type: "select-add",
          selectContent: [],
          col: 24,
        },
        {
          // visible: configuration?.institution?.userCanChangeBilling,
          label: t("institutionsDetailInputs.groupedBilling"),
          description: t("institutionsDetailInputs.groupedBillingDescription"),
          name: "groupedBilling",
          disabled: !onlyRoleMapping([roles.superAdmin]),
          type: "checkbox-bool",
          value: id === "new" ? true : groupedBilling,
          col: 24,
        },
        // {
        //   visible: configuration?.institution?.userCanChangeBilling,
        //   label: t("institutionsDetailInputs.groupedBilling"),
        //   description: t("institutionsDetailInputs.groupedBillingDescription"),
        //   name: "groupedBilling",
        //   disabled: true,
        //   type: "checkbox-bool",
        //   value: groupedBilling,
        //   col: 24,
        // },
        {
          label: t("institutionsDetailInputs.minimumDurationLabel"),
          description: t("institutionsDetailInputs.minimumDurationDescription"),
          name: "minimumMinutesTranches",
          type: "checkbox-bool",
          value: minimumMinutesTranches,
          col: 24,
        },
        {
          visible: userHasLevel({
            only: {
              [roles.admin]: "crud", //
            },
          }),
          label: t("institutionsDetailInputs.restrictionPerApplicant"),
          name: "restrictionPerApplicant",
          type: "checkbox-bool",
          value: restrictionPerApplicant,
          description: t(
            "institutionsDetailInputs.restrictionPerApplicantDescription",
          ),
          col: 24,
        },{
          visible: userHasLevel({
            only: {
              [roles.admin]: "crud", //
            },
          }),
          label: t("institutionsDetailInputs.includeSignInBill"),
          name: "includeSignInBill",
          type: "checkbox-bool",
          value: includeSignInBill,

          col: 24,
        },
      ],
    },
    {
      visible: configuration?.institution?.userCanChangeBilling,
      parentLabel: t("institutionsDetailInputs.billing"),
      children: [
        {
          label: null,
          name: "billings",
          type: "component",
          component: ({}) => {
            return (
              <div>
                <BillingsType
                  description={t(
                    "InstitutionsDetailInputs.groupedBillingDescription",
                  )}
                  billings={billings}
                  name={"billings"}
                  refForm={formRef}
                />
              </div>
            );
          },
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label:
            id === "new"
              ? t("institutionsDetailInputs.createInstitution")
              : t("institutionsDetailInputs.save"),
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
};
